/**
 * Payment-module constants.
 *
 * BINDER_NEEDED_STATUSES — workflow statuses set by the backend after
 * payment is confirmed but before the binder/invoice is generated. When
 * the dashboard "Resume" button sees one of these, it routes to
 * /binder-invoice instead of the regular wizard step.
 */
export const BINDER_NEEDED_STATUSES = new Set(["binding policy"]);
